/* global document */
import { useEffect, useState } from 'react';

/**
 * Custom hook to get a portal container by its ID.
 * @param {string} containerId - The ID of the container to get.
 * @returns {HTMLElement|null} - The portal container element or null if not found.
 */
const usePortalContainer = (containerId) => {
    const [container, setContainer] = useState(null);

    useEffect(() => {
        setContainer(typeof window !== 'undefined'
            ? document.getElementById(containerId)
            : null);
    }, [containerId]);

    return container;
};

export default usePortalContainer;